import BaseHead from "../templates/BaseHead";
import { getSubdomain } from "../../utils/getSubdomain";
import STUtils from "../../assets/styles/utility.module.scss";
import BoardCategories from "../organisms/BoardCategoriesForumPage";
import BottomNavigationBar from "../organisms/BottomNavigationBar";
import STBoardCategories from "../../assets/styles/organisms/boardCategoriesForumPage.module.scss";

const BoardCategoriesForumPage = () => {
  const subdomain = getSubdomain(window.location.hostname);
  return (
    <BaseHead
      title="掲示板のカテゴリ"
      login={true}
      subdomain={subdomain}
      hasBackground
      hasNavigationBar={true}
    >
      <div
        className={`${STUtils.container_large} ${STBoardCategories.custom_container}`}
      >
        <BoardCategories />
        <div style={{ marginBottom: "24px" }}>
          <BottomNavigationBar />
        </div>
      </div>
    </BaseHead>
  );
};

export default BoardCategoriesForumPage;
